export enum AppVersion {
  Maintanence = 'MAINTANENCE',
  Stable = 'STABLE-2025-03-10',
}

export const reloadWindow = (): void => {
  window.location.reload()
}
